import SMHSDK from '@/renderer/scripts/libs/smh-sdk-class';
class CancelRequest {
  private source = SMHSDK.gererateCancelSource();
  get token() {
    return this.source.token;
  }
  cancel() {
    this.source.cancel('canceled');
    this.reset();
  }
  private reset() {
    this.source = SMHSDK.gererateCancelSource();
  }
}
export default new CancelRequest();
